import ApiRequest from '../request'

export default class Coproprietaires {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async coproprietairesFromMonday(params) {
    try {
      const res = await this.apiRequest.get(
        `coproprietaires_frommonday`,
        params
      )
      return res
    } catch (error) {
      return error.response
    }
  }
  async getTicketsCoproprietaire(coproprietaire_id, params = {}) {
    try {
      const res = await this.apiRequest.get(
        `ext_coproprietaires/${coproprietaire_id}/tickets`,
        params
      )
      return res
    } catch (error) {
      return error.response
    }
  }
  async getCoproprietaire(coproprietaire_id) {
    try {
      const res = await this.apiRequest.get(
        `coproprietaires/${coproprietaire_id}`
      )
      return res
    } catch (error) {
      return error.response
    }
  }
}
